import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { TopbarComponent } from './topbar/topbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { StatusBarComponent } from './status-bar/status-bar.component';
import { BrandLogoComponent } from '../shared/brand-logo/brand-logo.component';
import { DmpIconComponent } from '../shared/icons/dmp-icon.component';
import { BrandingPreviewBannerComponent } from './branding-preview-banner/branding-preview-banner.component';

@NgModule({
  declarations: [
    LayoutComponent,
    TopbarComponent,
    SidebarComponent,
    StatusBarComponent,
  ],
  imports: [CommonModule, RouterModule, BrandLogoComponent, DmpIconComponent, BrandingPreviewBannerComponent],
  exports: [LayoutComponent],
})
export class LayoutModule {}
